import React, { useState } from "react";

const SERVIZI = [
  "Medicazioni semplici",
  "Medicazioni complesse",
  "Rimozione punti di sutura",
  "ECG con refertazione",
  "Holter cardiaco",
  "Holter pressorio",
  "Ecografie infermieristiche",
  "Iniezioni / infusioni",
  "Cateterismo vescicale",
  "Cateterismo venoso",
  "Tampone Streptocco A",
  "Screening capillari",
  "Educazione sanitaria",
  "M.O.C densitometria calcaneare",
  "Educazione sanitaria",
  "Servizio a Domicilio (inserire note)",
];

export default function Prenotazioni() {
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    prestazione: "",
    note: "",
  });

  const [showPreview, setShowPreview] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const testoPrenotazione = () => `
Richiesta prestazione infermieristica – Medicajato Center

Nome e Cognome: ${formData.nome}
Email: ${formData.email}
Prestazione richiesta: ${formData.prestazione}
Note: ${formData.note || "Nessuna"}
`;

  const inviaEmail = () => {
    setIsSending(true);
    const subject = encodeURIComponent("Richiesta prestazione infermieristica – Medicajato Center");
    const body = encodeURIComponent(testoPrenotazione());
    window.location.href = `mailto:info@medicajato.it?subject=${subject}&body=${body}`;
    setTimeout(() => setIsSending(false), 1000);
  };

  const inviaWhatsApp = () => {
    setIsSending(true);
    const msg = encodeURIComponent(testoPrenotazione());
    window.open(`https://wa.me/393383395427?text=${msg}`, "_blank");
    setTimeout(() => setIsSending(false), 1000);
  };

  return (
    <div style={{ padding: 20, maxWidth: 600, margin: "0 auto", fontFamily: "Arial, sans-serif" }}>
      <h1>Richiedi una prestazione infermieristica</h1>

      <p style={{ color: "#555", marginBottom: 20 }}>
        Compila il modulo per inviare una richiesta di prestazione.
        La disponibilità verrà confermata dallo studio.
      </p>

      <input
        name="nome"
        placeholder="Nome e Cognome"
        value={formData.nome}
        onChange={handleChange}
        required
        style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ccc" }}
      /><br /><br />

      <input
        name="email"
        type="email"
        placeholder="Email"
        value={formData.email}
        onChange={handleChange}
        required
        style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ccc" }}
      /><br /><br />

      <select
        name="prestazione"
        value={formData.prestazione}
        onChange={handleChange}
        required
        style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ccc" }}
      >
        <option value="">Seleziona la prestazione</option>
        {SERVIZI.map((s, i) => (
          <option key={i} value={s}>{s}</option>
        ))}
      </select><br /><br />

      <textarea
        name="note"
        placeholder="Note aggiuntive (facoltative)"
        value={formData.note}
        onChange={handleChange}
        rows={3}
        style={{ width: "100%", padding: 10, borderRadius: 10, border: "1px solid #ccc" }}
      /><br /><br />

      <button
        onClick={() => setShowPreview(true)}
        disabled={!formData.nome || !formData.email || !formData.prestazione}
        style={{
          padding: "14px 24px",
          borderRadius: 16,
          border: "none",
          backgroundColor: "#0d6efd",
          color: "#fff",
          fontWeight: 600,
          cursor: "pointer"
        }}
      >
        Anteprima richiesta
      </button>

      {/* PREVIEW */}
      {showPreview && (
        <div style={{
          marginTop: 20,
          padding: 20,
          border: "1px solid #ddd",
          borderRadius: 16,
          backgroundColor: "#fafafa"
        }}>
          <h3>Conferma e invia richiesta</h3>

          <pre style={{ whiteSpace: "pre-wrap", fontSize: 14 }}>
            {testoPrenotazione()}
          </pre>

          <button
            onClick={inviaWhatsApp}
            disabled={isSending}
            style={{
              width: "100%",
              padding: 14,
              borderRadius: 20,
              border: "none",
              backgroundColor: "#25D366",
              color: "#fff",
              fontWeight: 600,
              marginBottom: 10,
              cursor: "pointer"
            }}
          >
            💬 Invia tramite WhatsApp
          </button>

          <button
            onClick={inviaEmail}
            disabled={isSending}
            style={{
              width: "100%",
              padding: 14,
              borderRadius: 20,
              border: "1px solid #d1d1d6",
              backgroundColor: "#fff",
              color: "#007aff",
              fontWeight: 600,
              marginBottom: 10,
              cursor: "pointer"
            }}
          >
            📧 Invia tramite Email
          </button>

          <button
            onClick={() => setShowPreview(false)}
            style={{
              width: "100%",
              padding: 12,
              borderRadius: 20,
              border: "none",
              backgroundColor: "#eee",
              cursor: "pointer"
            }}
          >
            Annulla
          </button>
        </div>
      )}

      {/* CALENDARIO */}
      <h2 style={{ marginTop: 40 }}>Disponibilità</h2>

      <button
        onClick={() => window.open(
          "https://calendar.google.com/calendar/appointments/schedules/AcZssZ20ZkuPpSKFXolE3rfnxas_ddHue-TmQ2yPSUyLD09oNP_2oYzEJCXoTOoAWchQ2GATrce94kX_?gv=true",
          "_blank"
        )}
        style={{
          padding: "12px 20px",
          borderRadius: 14,
          border: "none",
          backgroundColor: "#f1f3f5",
          cursor: "pointer"
        }}
      >
        📅 Apri calendario
      </button>

      <iframe
        src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ20ZkuPpSKFXolE3rfnxas_ddHue-TmQ2yPSUyLD09oNP_2oYzEJCXoTOoAWchQ2GATrce94kX_?gv=true"
        style={{ border: 0, width: "100%", height: 500, marginTop: 20 }}
        title="Calendario"
      />
    </div>
  );
}
